export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-disabled-1200-4c762ea8fc7f5145ce5ad544535805f6.png";